"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemSet = void 0;
/**
 * Module representing Great Minds item set information.
 *
 * @property {string}           id
 * @property {string}           name
 *
 * @author fabian.perez
 */
var ItemSet = /** @class */ (function () {
    function ItemSet(itemSet) {
        if (itemSet === void 0) { itemSet = {}; }
        Object.assign(this, itemSet);
    }
    return ItemSet;
}());
exports.ItemSet = ItemSet;
